export enum CameraPermissionStatus {
  Pending,
  Granted,
  Denied,
}

export enum CameraPermission {
  Prompt = 'prompt',
  Granted = 'granted',
  Denied = 'denied',
}
